/** Escape workspace stacking contexts while retaining the web skin's CSS scope. */
export function webPortalTarget(): Element {
  return document.querySelector('.desktop-app') || document.body;
}
